import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="app">
      <div className="main">
        <div style={{ maxWidth: 480, margin: '80px auto', textAlign: 'center' }}>
          <div className="eyebrow">404 · Not Found</div>
          <h1 className="h-display" style={{ fontSize: 88, marginBottom: 16 }}>404</h1>
          <p className="lead" style={{ margin: '0 auto 28px' }}>
            That casting number doesn't match anything in our catalog.
          </p>
          <Link to="/" className="btn">← Back to home</Link>
        </div>
      </div>
    </div>
  );
}
